import React, { useState } from "react";

import { IGroupedPeriodStatisticsChartData } from "@data-types/sport-stats/SportStatsTypes";
import classnames from "classnames";

import { EventStatsGroupHeader, EventStatsGroupBody } from ".";

export function EventStatsGroup(props: {
	statsGroup: IGroupedPeriodStatisticsChartData;
	index?: number;
}) {
	const [isExpanded, setExpand] = useState(true);

	const isWeb = window.innerWidth > 768;

	const containerElClasses = classnames("card card--stats", {
		"u-mar--bottom--xsml": isWeb,
	});

	return (
		<div key={props.index} className={containerElClasses}>
			<EventStatsGroupHeader
				isExpanded={isExpanded}
				onSetExpand={setExpand}
				title={props.statsGroup.title}
			/>

			<EventStatsGroupBody
				isExpanded={isExpanded}
				statsData={props.statsGroup.data}
			/>
		</div>
	);
}
